<router-outlet></router-outlet>

<!-- Close Icon injector used for modal service - will not render as it only contains a template
NB!!!!!!!! Whatever you do... make sure this doesn't get run on server side... just trust me on this
It will cause a memory leak on the server and you will start sacrificing your soul to try and find it-->
@if (isBrowser) {
    <icon-close-injector></icon-close-injector>
}
